import { ExportDataEntityEnum } from '../../../../shared/models';
import { PropertyTypeEnum } from '../../../../shared/properties';
import { generateViewColumnKeyFromMapping, ViewColumn } from '../../view';
import { companyViewColumnDefinition } from '../../view/company-view-column.definition';
import {
  ExportColumnDefinition,
  ExtractKeys,
} from './export-data-column.definition';

export const COMPANY_EXPORT_DATA_COLUMN_KEYS = [
  'company_name',
  'company_commercial_name',
  'company_registration_number',
  'company_registration_date',
  'company_status',
  'company_legal_form',
  'company_country',
  'company_classifications',
  'company_website_url',
  'company_employer_identification_number',
  'company_type',
  'company_address_street_address',
  'company_address_street_address_2',
  'company_address_city',
  'company_address_state',
  'company_address_region',
  'company_address_country',
  'company_tax_identification_number',
  'company_banking_information_iban',
  'company_banking_information_bic',
  'company_created_at',
  'company_updated_at',
] as const;

// Type-safe keys type
export type CompanyExportDataColumnKey = ExtractKeys<
  typeof COMPANY_EXPORT_DATA_COLUMN_KEYS
>;

export const companyExportDataColumnDefinitionMap: Record<
  CompanyExportDataColumnKey,
  ViewColumn<PropertyTypeEnum, PropertyTypeEnum>
> = {
  company_name: companyViewColumnDefinition.name,
  company_commercial_name: companyViewColumnDefinition.commercialName,
  company_registration_number: companyViewColumnDefinition.registrationNumber,
  company_registration_date: companyViewColumnDefinition.registrationDate,
  company_status: companyViewColumnDefinition.status,
  company_legal_form: companyViewColumnDefinition.legalForm,
  company_country: companyViewColumnDefinition.country,
  company_classifications: companyViewColumnDefinition.classifications,
  company_website_url: companyViewColumnDefinition.websiteUrl,
  company_employer_identification_number:
    companyViewColumnDefinition.employerIdentificationNumber,
  company_type: companyViewColumnDefinition.type,
  company_address_street_address:
    companyViewColumnDefinition['address.streetAddress'],
  company_address_street_address_2:
    companyViewColumnDefinition['address.streetAddress2'],
  company_address_city: companyViewColumnDefinition['address.city'],
  company_address_state: companyViewColumnDefinition['address.state'],
  company_address_region: companyViewColumnDefinition['address.region'],
  company_address_country: companyViewColumnDefinition['address.country'],
  company_tax_identification_number:
    companyViewColumnDefinition.taxIdentificationNumber,
  company_banking_information_iban:
    companyViewColumnDefinition['bankingInformation.iban'],
  company_banking_information_bic:
    companyViewColumnDefinition['bankingInformation.bic'],
  company_created_at: companyViewColumnDefinition.createdAt,
  company_updated_at: companyViewColumnDefinition.updatedAt,
};

export const companyViewColumnKeyToExportColumnKey: Record<
  string,
  CompanyExportDataColumnKey
> = Object.entries(companyExportDataColumnDefinitionMap).reduce(
  (acc, [key, { mapping }]) => {
    acc[generateViewColumnKeyFromMapping(mapping)] =
      key as CompanyExportDataColumnKey;
    return acc;
  },
  {} as Record<string, CompanyExportDataColumnKey>,
);

export const companyExportDataColumnDefinition: ExportColumnDefinition<CompanyExportDataColumnKey>[] =
  COMPANY_EXPORT_DATA_COLUMN_KEYS.map((companyColumnKey) => ({
    uniqueKey: companyColumnKey,
    sourceEntity: ExportDataEntityEnum.company,
    viewColumn: companyExportDataColumnDefinitionMap[companyColumnKey],
  }));
